/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CryptoAddressesList } from '../models/CryptoAddressesList';
import type { CryptoAddressGenerateResponse } from '../models/CryptoAddressGenerateResponse';
import type { PromoCodeResponse } from '../models/PromoCodeResponse';
import type { ReferralCodeCreateResponse } from '../models/ReferralCodeCreateResponse';
import type { ReferralCodeDetails } from '../models/ReferralCodeDetails';
import type { ReferralCodeUseResponse } from '../models/ReferralCodeUseResponse';
import type { ReferralCutClaimResponse } from '../models/ReferralCutClaimResponse';
import type { UserBalance } from '../models/UserBalance';
import type { UserDropsList } from '../models/UserDropsList';
import type { UserProfileWithOpenings } from '../models/UserProfileWithOpenings';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProfileService {
    /**
     * Get user profile details
     * Returns the authenticated user's profile information, opening statistics, and level progression (levelXp, currentLevel, nextLevelXp)
     * @returns UserProfileWithOpenings User profile and statistics
     * @throws ApiError
     */
    public static getV1ProfileMe(): CancelablePromise<UserProfileWithOpenings> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/profile/me',
            errors: {
                401: `Not authenticated`,
            },
        });
    }
    /**
     * Get user balance
     * Returns the user's current balance and case tokens
     * @returns UserBalance User balance information
     * @throws ApiError
     */
    public static getV1ProfileMeBalance(): CancelablePromise<UserBalance> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/profile/me/balance',
            errors: {
                401: `Not authenticated`,
            },
        });
    }
    /**
     * Set Steam trade URL
     * Updates the user's Steam trade URL for item withdrawals
     * @param requestBody
     * @returns any Trade URL updated successfully
     * @throws ApiError
     */
    public static postV1ProfileMeTradeUrl(
        requestBody: {
            /**
             * Steam trade URL
             */
            tradeUrl: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/profile/me/trade-url',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid trade URL`,
                401: `Not authenticated`,
            },
        });
    }
    /**
     * Set Steam email
     * Updates the user's email for marketing and notifications
     * @param requestBody
     * @returns any Email updated successfully
     * @throws ApiError
     */
    public static postV1ProfileMeEmail(
        requestBody: {
            /**
             * email of user
             */
            email: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/profile/me/email',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `invalid email`,
                401: `Not authenticated`,
            },
        });
    }
    /**
     * Verify email address
     * Verify the user's email address
     * @throws ApiError
     */
    public static getV1ProfileMeEmailVerify(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/profile/me/email/verify',
        });
    }
    /**
     * Use a promo code
     * Apply a promo code to the authenticated user's account
     * @param requestBody
     * @returns PromoCodeResponse Promo code used successfully
     * @throws ApiError
     */
    public static postV1ProfileMePromoCode(
        requestBody: {
            /**
             * The promo code to use
             */
            promoCode: string;
        },
    ): CancelablePromise<PromoCodeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/profile/me/promo-code',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid promo code`,
                401: `Not authenticated`,
                429: `Rate limit exceeded`,
            },
        });
    }
    /**
     * Get user's referral code details
     * Returns the authenticated user's referral code information and statistics
     * @returns ReferralCodeDetails Referral code details
     * @throws ApiError
     */
    public static getV1ProfileMeReferralCode(): CancelablePromise<ReferralCodeDetails> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/profile/me/referral-code',
            errors: {
                401: `Not authenticated`,
                404: `User does not have a referral code`,
            },
        });
    }
    /**
     * Create a new referral code
     * Creates a new referral code for the authenticated user
     * @param requestBody
     * @returns ReferralCodeCreateResponse Referral code created successfully
     * @throws ApiError
     */
    public static postV1ProfileMeReferralCodeCreate(
        requestBody: {
            /**
             * The desired referral code
             */
            referralCode: string;
        },
    ): CancelablePromise<ReferralCodeCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/profile/me/referral-code/create',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid code or code already exists`,
                401: `Not authenticated`,
                409: `User already has a referral code`,
            },
        });
    }
    /**
     * Use a referral code
     * Apply a referral code to the authenticated user's account
     * @param requestBody
     * @returns ReferralCodeUseResponse Referral code used successfully
     * @throws ApiError
     */
    public static postV1ProfileMeReferralCodeUse(
        requestBody: {
            /**
             * The referral code to use
             */
            referralCode: string;
        },
    ): CancelablePromise<ReferralCodeUseResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/profile/me/referral-code/use',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid referral code`,
                401: `Not authenticated`,
                409: `User has already used a referral code`,
                429: `Rate limit exceeded`,
            },
        });
    }
    /**
     * Claim referral earnings
     * Claim available earnings from referral code usage
     * @returns ReferralCutClaimResponse Referral cut claimed successfully
     * @throws ApiError
     */
    public static postV1ProfileMeReferralCodeClaimCut(): CancelablePromise<ReferralCutClaimResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/profile/me/referral-code/claim-cut',
            errors: {
                400: `No earnings available to claim`,
                401: `Not authenticated`,
                404: `User does not have a referral code`,
            },
        });
    }
    /**
     * Get user's crypto addresses
     * Returns all crypto addresses associated with the authenticated user
     * @returns CryptoAddressesList List of crypto addresses
     * @throws ApiError
     */
    public static getV1ProfileMeCryptoAddresses(): CancelablePromise<CryptoAddressesList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/profile/me/crypto-addresses',
            errors: {
                401: `Not authenticated`,
            },
        });
    }
    /**
     * Request a new crypto address
     * Request a new cryptocurrency address for deposits
     * @param requestBody
     * @returns CryptoAddressGenerateResponse Crypto address generated successfully
     * @throws ApiError
     */
    public static postV1ProfileMeCryptoAddressesRequest(
        requestBody: {
            /**
             * Type of cryptocurrency address to generate
             */
            coinType: 'BTC' | 'ETH' | 'USDT';
        },
    ): CancelablePromise<CryptoAddressGenerateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/profile/me/crypto-addresses/request',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid coin type or address generation failed`,
                401: `Not authenticated`,
                409: `Address already exists for this coin type`,
            },
        });
    }
    /**
     * Get user's item drops
     * Returns all items won by the authenticated user from case openings
     * @param page Page number for pagination
     * @param pageSize Number of items per page
     * @returns UserDropsList List of won items
     * @throws ApiError
     */
    public static getV1ProfileMeDrops(
        page: number = 1,
        pageSize: number = 20,
    ): CancelablePromise<UserDropsList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/profile/me/drops',
            query: {
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                401: `Not authenticated`,
            },
        });
    }
}
